enum AppointmentType {
    IN_PERSON = 'in_person',
    REMOTE    = 'remote',
    BOTH      = 'both'
}

export default AppointmentType;
